import * as React from 'react';
import cn from 'classnames';

export interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
    label: string;
    isRequired?: boolean;
}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(({ className, label, isRequired, ...props }, ref) => {
    return (
        <div className="flex w-full flex-col gap-2">
            {label && (
                <label className="anonymize-p3 text-black-700">
                    {label}
                    {!!isRequired && <span className="text-red-500">*</span>}
                </label>
            )}
            <textarea className={cn('border-input anonymize-p4 flex min-h-[80px] w-full rounded-[4px] border px-[13px] py-3  text-black-800 placeholder:text-black-400', className)} ref={ref} {...props} />
        </div>
    );
});
Textarea.displayName = 'Textarea';

export { Textarea };
